function Collapse(element) {
    this.root = element;
    this.collapseItems = this.root.querySelectorAll(".collapse-item");

    this.init();
    this.registerClicks();
}

Collapse.prototype.init = function () {
    const instance = this;

    this.collapseItems.forEach((collapseItem, index) => {
        const collapseContent = collapseItem.querySelector(".collapse-content");
        collapseContent.setAttribute("data-height", collapseContent.offsetHeight);
        collapseContent.style.height = "0";
    });
};

Collapse.prototype.registerClicks = function () {
    const instance = this;

    this.collapseItems.forEach((collapseItem, index) => {
        const collapseButton = collapseItem.querySelector(".collapse-button");
        const collapseContent = collapseItem.querySelector(".collapse-content");
        const collapsePlus = collapseItem.querySelector(".collapse-button .icon-plus");

        collapseButton.addEventListener("click", function () {
            if (collapseContent.style.height === "0px" || collapseContent.style.height === "") {
                instance.open(index);
                collapsePlus.classList.add("active");
                collapseContent.classList.add("pb-6");
            } else {
                instance.close(index);
                collapseContent.classList.remove("pb-6");
                collapsePlus.classList.remove("active");
            }
        });
    });
};

Collapse.prototype.toggle = function (index) {
    const collapseItem = this.collapseItems[index];
    const collapseContent = collapseItem.querySelector(".collapse-content");
    const collapsePlus = collapseItem.querySelector(".collapse-button .icon-plus");

    if (collapseContent.style.height === "0px" || collapseContent.style.height === "") {
        this.open(index);
        collapsePlus.classList.add("active");
        collapseContent.classList.add("pb-6");
    } else {
        this.close(index);
        collapseContent.classList.remove("pb-6");
        collapsePlus.classList.remove("active");
    }
};

Collapse.prototype.open = function (index) {
    const collapseItem = this.collapseItems[index];
    const collapseContent = collapseItem.querySelector(".collapse-content");
    const height = collapseContent.dataset.height;
    const collapsePlus = collapseItem.querySelector(".collapse-button .icon-plus");

    this.collapseItems.forEach((item, i) => {
        if (i !== index) {
            this.close(i);
            collapseContent.classList.remove("pb-6");
            collapsePlus.classList.remove("active");
        }
    });

    collapseContent.style.height = `${+height + 24}px`;
};

Collapse.prototype.close = function (index) {
    const collapseItem = this.collapseItems[index];
    const collapseContent = collapseItem.querySelector(".collapse-content");
    const collapsePlus = collapseItem.querySelector(".collapse-button .icon-plus");
    const collapseMinus = collapseItem.querySelector(".collapse-button .icon-minus");

    // Add your additional classes for closing here
    // For example, you can add the class "closed" to the collapse content
    collapseContent.classList.remove("pb-6");
    collapsePlus.classList.remove("active");
    collapseContent.style.height = "0";
};

// Usage example:
document.addEventListener("DOMContentLoaded", function () {
    const collapseElements = document.querySelectorAll(".faq.collapse");

    collapseElements.forEach(function (collapseElement) {
        new Collapse(collapseElement);
    });
});